export default function AboutMe() {
  return (
    <section id="AboutMe" className="about--section">
      <div className="about--section--img">
        <img src="./img/Iceland png/glacier.png" alt="About Me" />
      </div>
      <div className="hero--section--content--box about--section--box">
        <div className="hero--section--content">
          <p className="section--title">About</p>
          <h1 className="skills-section--heading">About Me</h1>
          <p className="hero--section-description">
          As an aspiring web developer, I bring a blend of technical proficiency, creative problem-solving, and a passion for innovation to the table. With a solid foundation in front-end development and data analysis. I thrive in dynamic environments where I can leverage my skills to create impactful and user-centric web experiences. 
          </p>
          <p className="hero--section-description">
          My commitment to continuous learning, attention to detail, and collaborative mindset make me a valuable asset to any development team. I am driven by a desire to push boundaries, embrace challenges, and contribute to projects that make a difference. 
          </p>
        </div>
      </div>
    </section>
  );
}
